import { Box } from '@mui/material'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props
  const isActive = value === index

  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={isActive ? { height: '100%' } : undefined}
      {...other}
    >
      <Box
        sx={{
          height: '100%',
          display: isActive ? 'block' : 'none',
        }}
      >
        {children}
      </Box>
    </div>
  )
}

export default TabPanel
